// why "any"? cause the need of overriding props that library does not support
export const getReadingGuidedTour: any = ({
  screenMode,
  sectionCount,
  minutes,
  isOnlyOneTestSectionAndOneQuestionGroup,
}) => {
  switch (screenMode) {
    case 'tablet': {
      return [
        {
          target: '.time-limit',
          title: 'Thời gian làm bài',
          content: `Bạn có ${minutes}' để làm cả ${sectionCount} passages.  Bạn có thể làm passage nào trước cũng được.`,
          disableBeacon: true,
          placement: 'auto',
          spotlightPadding: 2,
          styles: {
            spotlight: {
              borderRadius: 0,
            },
          },
        },
        {
          target: '.do-test-footer .dol-progress-bar:first-child',
          title: 'Chuyển đổi passages',
          content: 'Dùng thanh này để chuyển thứ tự giữa các passage.',
          placement: 'top-start',
          spotlightPadding: 6,
        },
        {
          target: '.btn-question-navigation',
          title: 'Chuyển giữa các nhóm câu hỏi',
          content: 'Dùng để qua lại giữa các nhóm câu hỏi trong 1 passage.',
        },
        {
          target: '.btn-review-submit',
          title: 'Xem lại các câu hỏi đã làm',
          content: 'Click vào nút này để xem các câu hỏi bạn đã làm hoặc chưa làm.',
          placement: 'top-start',
          spotlightPadding: 6,
        },
        {
          target: '.btn-submit-do-test',
          title: 'Nộp bài',
          content: `Khi tới passage thứ ${sectionCount}, câu hỏi cuối cùng bạn sẽ thấy nút nộp bài.`,
          styles: {
            spotlight: {
              borderRadius: 8,
            },
          },
        },
      ];
    }

    case 'mobile': {
      return [
        {
          target: '.time-limit',
          title: 'Thời gian làm bài',
          content: `Bạn có ${minutes}' để làm cả ${sectionCount} passages.  Bạn có thể làm passage nào trước cũng được`,
          disableBeacon: true,
          placement: 'auto',
          spotlightPadding: 2,
          styles: {
            spotlight: {
              borderRadius: 0,
            },
          },
        },
        {
          target: '.do-test-footer .dol-progress-bar:first-child',
          title: 'Chuyển đổi passages',
          content: 'Dùng thanh này để chuyển thứ tự giữa các passage.',
          placement: 'top-start',
          spotlightPadding: 6,
        },
        {
          target: '.btn-question-navigation',
          title: 'Chuyển giữa các nhóm câu hỏi',
          content: 'Dùng để qua lại giữa các nhóm câu hỏi trong 1 passage.',
        },
        {
          target: '.btn-switch-view-mode',
          title: 'Chuyển giữa câu hỏi và passage',
          content: 'Dùng để qua lại giữa phần câu hỏi và passage.',
          styles: {
            spotlight: {
              borderRadius: '50%',
            },
          },
        },
        {
          target: '.btn-review-submit',
          title: 'Xem lại các câu hỏi đã làm',
          content: 'Click vào nút này để xem các câu hỏi bạn đã làm hoặc chưa làm.',
          placement: 'top-start',
          spotlightPadding: 6,
        },
        {
          target: '.btn-submit-do-test',
          title: 'Nộp bài',
          content: `Khi tới passage thứ ${sectionCount}, câu hỏi cuối cùng bạn sẽ thấy nút nộp bài.`,
          styles: {
            spotlight: {
              borderRadius: 8,
            },
          },
        },
      ];
    }

    default:
  }
  return [
    {
      target: '.time-limit',
      title: 'Thời gian làm bài',
      content: `Bạn có ${minutes}' để làm cả ${sectionCount} passages.  Bạn có thể làm passage nào trước cũng được.`,
      disableBeacon: true,
      placement: 'left-start',
      styles: {
        spotlight: {
          borderRadius: '12px 0 0 12px',
        },
      },
    },
    {
      target: '.button-test-section:first-child .badge',
      title: 'Chuyển đổi passages',
      content: 'Dùng thanh này để chuyển thứ tự giữa các passage.',
      placement: 'top-start',
      spotlightPadding: 6,
    },
    {
      target: '.btn-expand-collapse-bottom-navigation-bar',
      title: 'Mở rộng/thu nhỏ thanh điều khiển',
      content: 'Dùng nút này để mở rộng hoặc thu gọn thanh điều khiển các câu hỏi',
      placement: 'top-start',
      spotlightPadding: 8,
    },
    isOnlyOneTestSectionAndOneQuestionGroup
      ? null
      : {
          target: '.all-question-info',
          title: 'Chuyển các câu hỏi',
          content: 'Dùng thanh này để chuyển giữa và review các câu hỏi trong 1 passage',
          placement: 'top-start',
        },
    {
      target: '.btn-submit-do-test',
      title: 'Nộp bài',
      content: `Khi tới passage thứ ${sectionCount}, câu hỏi cuối cùng bạn sẽ thấy nút nộp bài.`,
      placement: 'top-start',
      styles: {
        spotlight: {
          borderRadius: 8,
        },
      },
    },
  ].filter(Boolean);
};
